import React from 'react';
import PropTypes from 'prop-types';
import setClass from '../../common/set-class';
import Icon from '../icon';
const SortIndicator = ({ sort, fieldName }) => {
    if (!RegExp(`^-?${fieldName}$`).test(sort)) {
        return null;
    }
    return (React.createElement(Icon, { name: "angle-down", size: "sm", className: setClass('b-table__sort-indicator', 'b-table__caret', sort === `-${fieldName}` && '--turned') }));
};
SortIndicator.propTypes = {
    sort: PropTypes.string,
    fieldName: PropTypes.string.isRequired,
};
SortIndicator.defaultProps = {
    sort: null,
};
const TableHeader = ({ columns, sort, setSort, withExpandColumn }) => (React.createElement("div", { className: "b-table__header-row" },
    withExpandColumn && React.createElement("div", { className: "b-table__cell b-table__expand_cell" }),
    columns.map(({ isSortable, className, fieldName, header, ratio, HeaderCell, }) => (React.createElement("div", { key: fieldName, className: setClass('b-table__cell', className, isSortable && '--sortable'), style: { flexGrow: ratio }, onClick: () => {
            if (!isSortable) {
                return;
            }
            if (sort === fieldName) {
                setSort(`-${fieldName}`);
            }
            else {
                setSort(fieldName);
            }
        } },
        HeaderCell && (React.createElement(HeaderCell, { SortIndicator: SortIndicator, sort: sort, fieldName: fieldName })),
        !HeaderCell && (React.createElement(React.Fragment, null,
            header,
            isSortable && (React.createElement(SortIndicator, { sort: sort, fieldName: fieldName })))))))));
TableHeader.propTypes = {
    sort: PropTypes.string,
    setSort: PropTypes.func,
    withExpandColumn: PropTypes.bool,
    columns: PropTypes.arrayOf(PropTypes.shape({
        isSortable: PropTypes.bool,
        className: PropTypes.string,
        fieldName: PropTypes.string.isRequired,
        header: PropTypes.string,
        ratio: PropTypes.number,
        HeaderCell: PropTypes.elementType,
    })).isRequired,
};
TableHeader.defaultProps = {
    sort: undefined,
    setSort: undefined,
    withExpandColumn: false,
};
export default TableHeader;
